import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insideImages, PURCHASE_ANCHOR } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      setIndex(Math.round(track.scrollLeft / track.clientWidth));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-87" data-mp="1dwequy1cyxm1">
      <div className="mx-auto max-w-3xl" data-id="element-88" data-mp="1dz9a4m8mycdv">
        <h2 className="text-center font-heading text-[1.2rem] font-bold uppercase text-navy sm:text-[1.9rem]" data-id="element-89" data-mp="a1whg48ebc27">
          Look inside
        </h2>
        <p className="mt-0.5 text-center font-body text-[0.8rem] font-bold text-clinical sm:text-[0.95rem]" data-id="element-90" data-mp="635j5ts71odi">
          Discover What’s Inside CLINICAL LAB VISUAL ATLAS™
        </p>
        <p className="mx-auto mt-0.5 max-w-xl text-center text-[0.7rem] leading-[1.35] text-muted sm:text-[0.82rem]" data-id="element-91" data-mp="f2akt8z1xxtw">
          Explore CBC patterns, blood-cell morphology, chemistry correlations,
          microbiology visuals, immunology maps, urinalysis findings, blood
          bank references, annotated comparisons and integrated laboratory
          resources included throughout the complete system.
        </p>

        <div className="relative mt-2" data-id="element-92" data-mp="3seud3yy5niqk">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto scroll-smooth rounded-md" aria-label="Carousel of pages inside CLINICAL LAB VISUAL ATLAS" data-id="element-93" data-mp="34qb6dnur7e0l">
            {insideImages.map((img, i) => <div key={img.src} className="w-full shrink-0 snap-center px-0.5" data-id="element-94" data-mp="18nokxwk3yqbo" data-mpi={i}>
                <a href={PURCHASE_ANCHOR} className="block" data-id="element-95" data-mp="18llnirgmluwx">
                  <img src={img.src} alt={`${img.caption} — page inside CLINICAL LAB VISUAL ATLAS™`} loading={i === 0 ? 'eager' : 'lazy'} className="w-full rounded-md border border-navy/15 bg-ivory object-contain shadow-md" data-id="element-96" data-mp="1df6malq1msx6" />
                </a>
              </div>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 -translate-y-1/2 rounded-full border border-navy/20 bg-white/95 p-2 text-navy shadow-md transition-opacity duration-150 ease-out disabled:opacity-30" data-id="element-97" data-mp="tpw7d9y4gc04">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-98" data-mp="2k941lcbwwzu8" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full border border-navy/20 bg-white/95 p-2 text-navy shadow-md transition-opacity duration-150 ease-out disabled:opacity-30" data-id="element-99" data-mp="2f9rfwuws1yt8">
            <ChevronRightIcon className="h-5 w-5" data-id="element-100" data-mp="21g08pt6iqr0o" />
          </button>
        </div>

        <p className="mt-1 text-center font-body text-[0.66rem] font-bold uppercase tracking-wide text-navy sm:text-xs" data-id="element-101" data-mp="1wlcqgc23ysuj">
          {index + 1} / {insideImages.length} — {insideImages[index].caption}
        </p>

        <div className="mt-1 flex justify-center gap-1.5" data-id="element-102" data-mp="1nky4dahbl9pz">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-5 bg-gold' : 'w-2 bg-navy/25'}`} data-id="element-103" data-mp="3hwmmfliulsel" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}